import * as React from 'react';

import {Button} from 'shells/button/button';
import {SlideshowControls} from 'shells/carousel/slideshow-controls';
import {FormField} from 'shells/form/form-field';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {FooterWithControls, ModalMain} from 'shells/modal/step-modal/layout';
import {BoldLabel} from 'shells/typography/bold-label';
import {ModalHeader} from 'shells/typography/modal-header';

import {CompetitorsList} from '../competitors-list';

type Props = {
    website: string;
    competitors: string[];
    onBack: () => void;
    onStartTracking: () => void;
};

export function ReviewSetup(props: Props) {
    const hasFullCompetitorIq = NutClientConfig.hasFullCompetitorIq;

    return (
        <>
            <ModalMain>
                <ModalHeader>Review setup</ModalHeader>
                <StackLegacy spacing={24}>
                    <StackLegacy spacing={8}>
                        <BoldLabel>Website</BoldLabel>
                        <FormField innerId='website' noMargin={true}>
                            <div className='mb-8 font-size-normal'>{props.website}</div>
                        </FormField>
                    </StackLegacy>
                    <StackLegacy spacing={8}>
                        <BoldLabel>Competitors</BoldLabel>
                        <CompetitorsList
                            competitors={props.competitors}
                            isInteractive={hasFullCompetitorIq}
                            isDisabled={!hasFullCompetitorIq}
                        />
                    </StackLegacy>
                </StackLegacy>
            </ModalMain>
            <FooterWithControls
                controls={<SlideshowControls selectedSlide={2} slideCount={3} />}
                buttons={
                    <>
                        <Button variant='primary' size='big' onClick={props.onBack}>
                            Back
                        </Button>
                        <Button variant='primary' size='big' onClick={props.onStartTracking}>
                            Start tracking
                        </Button>
                    </>
                }
            />
        </>
    );
}
